import * as React from "react";
import { CommonHelper } from "../../../../../../../../react-core/Helpers/CommonHelper";
import { SubAccountType } from "../../../../../../../../Wrap/Constants/Enums/Domain/SubAccountType";
import { ApplyModel } from "../../../../../../../../Wrap/Models/Models/Processes/Apply/ApplyModel";
import { RestrictionHelper } from "../../../../../../../Shared/Common/RestrictionHelper";
import { ProcessType } from "../../../../../../../Shared/IST/Resource/Content";
import { IProcessComponentProps, ProcessComponent } from "../../../../../../../Shared/Process/Process/ProcessComponent";
import { getQueryParameters } from "../../../../../../../Shared/Wizards/Entities/QueryParametersHelper";
import { ProcessTypeHelper } from "../../../../Common/Helpers/ProcessTypeHelper";
import { BankAccountAction } from "../../../../Common/PaymentsIn/BankAccount/BankAccountAction";
import { inUseBankAccountForApply } from "../../../../Common/PaymentsIn/BankAccount/BankAccountHelper";
import { RegularPayment } from "../../../../Common/PaymentsIn/RegularPayment/RegularPayment";
import { SinglePayment } from "../../../../Common/PaymentsIn/SinglePayment/SinglePayment";
import { TransferIn } from "../../../../Common/PaymentsIn/TransferIn/TransferIn";
import { PaymentType, processTypeEnum } from "../../../../Common/Resource/Contents";
import { RestrictionStore } from "../../../../Common/Restrictions/Variable";
import { nbPaymentsInMessages } from "../../../Resource/Contents";

interface IPaymentsInProps extends IProcessComponentProps {
    data: ApplyModel;
    transferDisabled: boolean;
    processType: ProcessType;
}

interface IPaymentsInState {}

export class PaymentsIn extends ProcessComponent<IPaymentsInProps, IPaymentsInState> {
    constructor(props: any) {
        super(props);
        this.state = {};
    }

    private getProps = (key) => {
        const { onChange, data, showErrorMsgPopUp, isReview, processType } = this.props;
        return {
            data: data[key],
            onRef: (ref) => this.appendChild(ref),
            showErrorMsgPopUp: (msg, isShow) => showErrorMsgPopUp(msg, isShow),
            onChange: (changes) => this.onDataChange(onChange, changes, data, key),
            isReview: isReview,
            onSaveNewBankAccountInstruction: (bankAccountInstruction) => {
                bankAccountInstruction.OwnerHierarchyId = data.OwnerHierarchyId;
                BankAccountAction.saveBankInstruction(
                    bankAccountInstruction,
                    data.ClientDetails?.ActorId,
                    ProcessTypeHelper.getProcessTypeEnum(processType),
                    (savedBankAccountInstruction) => {
                        const changes = [...data.BankAccountInstructions, ...[savedBankAccountInstruction]];
                        this.onDataChange(onChange, changes, data, "BankAccountInstructions");
                    }
                );
            },
            onRemoveBankAccountInstruction: (bankAccountInstruction) => {
                BankAccountAction.removeBankInstruction(bankAccountInstruction, () => {
                    const changes = (data.BankAccountInstructions || []).filter(
                        (x) => x.AccountNumber != bankAccountInstruction.AccountNumber
                    );
                    this.onDataChange(onChange, { BankAccountInstructions: changes }, data);
                });
            },
            inUseBankAccountInstruction: inUseBankAccountForApply(data),
        };
    };

    public isValid(): boolean {
        let isValid = super.isValid();
        isValid = isValid && this.atLeastOneContribution();
        if (!this.atLeastOneContribution()) {
            this.props.showErrorMsgPopUp([nbPaymentsInMessages.atLeastOneContribution]);
        }
        return isValid;
    }

    private atLeastOneContribution(): boolean {
        const { data } = this.props;

        return (
            data.GiaModel.ClientSinglePayment?.Money?.Amount > 0 ||
            data.GiaModel.ThirdPartySinglePayment?.Money?.Amount > 0 ||
            data.GiaModel.ClientRegularPayment?.Money?.Amount > 0 ||
            data.GiaModel.ThirdPartyRegularPayment?.Money?.Amount > 0 ||
            data.GiaModel.GiaTransfers?.length > 0
        );
    }
    public render(): JSX.Element {
        const { GiaModel, ClientDetails, AllBankAccounts, BankAccountInstructions } = this.props.data;
        const { data, onChange } = this.props;
        return (
            <div>
                <h2>Payments in</h2>
                <SinglePayment
                    {...this.getProps("GiaModel")}
                    clientInfo={ClientDetails}
                    checkBoxOption={[PaymentType.Client, PaymentType.ThirdParty]}
                    subAccountType={SubAccountType.InvestmentAccount}
                    bankAccounts={AllBankAccounts}
                    hasPaymentMethod={true}
                    bankAccountInstructions={BankAccountInstructions}
                    processType={
                        CommonHelper.isNullOrEmpty(getQueryParameters()["claccountid"])
                            ? processTypeEnum.NewBusinessExistingClient
                            : processTypeEnum.NewBusiness
                    }
                />
                <hr />
                <RegularPayment
                    {...this.getProps("GiaModel")}
                    clientInfo={ClientDetails}
                    bankAccounts={AllBankAccounts}
                    bankAccountInstructions={BankAccountInstructions}
                    checkBoxOption={[PaymentType.Client, PaymentType.ThirdParty]}
                    subAccountType={SubAccountType.InvestmentAccount}
                    hasPaymentMethod={true}
                    hasContinue={true}
                    hasIndexation={false}
                    processType={
                        CommonHelper.isNullOrEmpty(getQueryParameters()["claccountid"])
                            ? processTypeEnum.NewBusinessExistingClient
                            : processTypeEnum.NewBusiness
                    }
                />
                <hr />
                <TransferIn
                    subAccountType={SubAccountType.InvestmentAccount}
                    data={GiaModel?.GiaTransfers}
                    jouneryType={
                        CommonHelper.isNullOrEmpty(getQueryParameters()["claccountid"])
                            ? processTypeEnum.NewBusinessExistingClient
                            : processTypeEnum.NewBusiness
                    }
                    onChange={(changes) =>
                        this.onDataChange(
                            (changes) => this.onDataChange(onChange, changes, data, "GiaModel"),
                            changes,
                            GiaModel
                        )
                    }
                    disabled={
                        RestrictionStore.transferDisabled() &&
                        RestrictionHelper.shouldHandleRestriction(this.props.processType)
                    }
                    isReview={this.props.isReview}
                    showErrorMsgPopUp={this.props.showErrorMsgPopUp}
                    isPost={false}
                    onRef={(ref) => this.appendChild(ref)}
                    clientDetails={ClientDetails}
                    accountServiceProposition={this.props.data.AccountServiceProposition}
                />
            </div>
        );
    }
}
